/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import ErrorMessageComponent from "./components/ErrorMessageComponent";

require('./bootstrap');
require('./include/Pusher');
window.Bugsnag = require('@bugsnag/js')
var BugsnagPluginVue = require('@bugsnag/plugin-vue')

window.Bugsnag.start({
    apiKey: window.env.MIX_BUGSNAG_ID,
    plugins: [new BugsnagPluginVue()],
    releaseStage: window.env.APP_ENV,
    appVersion: window.env.APP_VERSION,
});

window.Vue = require('vue');

window.Bugsnag.getPlugin('vue').installVueErrorHandler(window.Vue)

Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
};

window.metaTitle = function (title) {
    document.title = 'SwiftWork | ' + title;
}

require('nprogress/nprogress.css');


import VueRouter from 'vue-router';
import BootstrapVue from 'bootstrap-vue';
import { mapActions } from 'vuex';
import VueQuillEditor from 'vue-quill-editor'
import vueDebounce from 'vue-debounce'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

window.Vue.use(VueQuillEditor)

window.Vue.use(vueDebounce)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this applicatio
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

window.Vue.use(BootstrapVue);
window.Vue.use(VueRouter);

import * as Router from "./routing/router";
import ErrorComponent from './components/ErrorComponent';
import store from './store';
import UsesErrors from "./mixins/UsesErrors";
import UsesInfoMessage from "./mixins/UsesInfoMessage";
import InfoMessage from "./components/InfoMessage";
import UserSelectComponent from "./components/UserSelectComponent";
import CommentsModalComponent from './components/CommentsModalComponent';
import Comments from './components/CommentsComponent';
import Modal from './components/modals/ModalComponent';
import { min } from "lodash";
import ActivityLogComponent from "./components/activityLogs/ActivityLogComponent.vue";
import CustomerSiteFooterLinks from "./components/forms/parts/CustomerSiteFooterLinks.vue";

/**
 * Filters
 */

const router = Router.router;

router.beforeEach(Router.beforeEach);
router.afterEach(Router.afterEach);

window.Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
});

window.Vue.filter('money', function (value) {
    if (!value) return '0.00';
    if (isNaN(value)) {
        return '0.00';
    }
    return parseFloat(value).toFixed(2);
});

window.Vue.filter('date', function (value) {
    if (!value) {
        return value;
    }

    return window.moment(value).format('DD/MM/YYYY');
});

window.Vue.filter('datetime', function (value) {
    if (!value) {
        return value;
    }

    return window.moment(value).format('DD/MM/YYYY H:ma');
});

window.Vue.filter('longdate', function (value) {
    if (!value) {
        return value;
    }

    return window.moment(value).format('Do MMM YYYY');
});

window.Vue.filter('minsToHours', function (total) {
    if (total == 0) {
        return '0 hrs';
    }
    const isNegative = total < 0;
    if (isNegative) {
        total = total * -1;
    }
    const hours = Math.floor(total / 60);
    const mins = total % 60;
    let s = '';
    if (isNegative) {
        s = '-';
    }
    if (hours) {
        s += `${hours} hrs`
    }
    if (mins && hours) {
        s += ' ';
    }
    if (mins) {
        s += `${mins} mins`;
    }
    return s;
});

window.Vue.filter('datetime', function (value) {
    if (!value) {
        return value;
    }

    return window.moment(value).format('DD/MM/YYYY HH:mm a');
});

window.Vue.filter('taskType', function (value) {
    const type = window.TaskTypes.find(t => t.value === value);

    return type ? type.label : value;
});

window.injectTelAndEmails = function (value) {
    if (!value) {
        return value;
    }

    return value.replace(/([\+\d\s]{5,16})/gi, '<a href="tel: $1">$1</a>').replace(/\b([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z0-9]{2,})\b/gi, '<a href="mailto: $1">$1</a>');
}

window.Vue.filter('injectTelAndEmails', window.injectTelAndEmails);

window.Vue.component('error', ErrorComponent);
window.Vue.component('error-message', ErrorMessageComponent);
window.Vue.component('info-message', InfoMessage);
window.Vue.component('user-select', UserSelectComponent);
window.Vue.component('comments-modal', CommentsModalComponent);
window.Vue.component('comments', Comments);
window.Vue.component('modal', Modal);
window.Vue.component('activity-log', ActivityLogComponent);
window.Vue.component('customer-site-footer-links', CustomerSiteFooterLinks);

const app = new window.Vue({
    mixins: [
        UsesErrors,
        UsesInfoMessage,
    ],
    router,
    store,
    el: '#app',
    watch: {
        $route: function () {
            this.clearErrors();
        }
    },
    mounted() {
        this.setupListener();
    },

    methods: {
        ...mapActions('comments', ['setupListener',]),
    },
});

window.$($ => {
    $('.splash-screen').fadeOut();
    $('[data-toggle="tooltip"]').tooltip()
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js